import { render, staticRenderFns } from "./RoleBox.vue?vue&type=template&id=1a4be9ae"
import script from "./RoleBox.vue?vue&type=script&lang=js"
export * from "./RoleBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports